import {useEffect} from "react";
import {get} from "../api/api";
import {useAuthStore} from "../store/authStore";
import {useAppStore} from "../store/appStore";
import {showMessage} from "../utils/snackbar";

export const useUserInit = () => {
    const idToken = useAuthStore(state => state.idToken);
    const userModel = useAppStore(state => state.userModel)

    useEffect(() => {
        const fetchUserModel = async () => {
            if (!idToken || userModel) return

            try {
                const userModel = await get("/me");
                useAppStore.setState({userModel});
            } catch (error: any) {
                if (error.code === "ERR_BAD_REQUEST") {
                    showMessage("Account niet gevonden.\n" +
                        "Neem contact op met de verantwoordelijke voor de koppeling met het Medendo-systeem om een account aan te maken.", "error", 600000);
                } else {
                    showMessage("Er is een fout opgetreden bij het ophalen van de gebruikersinformatie.", "error");
                }
                console.warn("Failed to fetch user info:", error);
            }
        }

        fetchUserModel();
    }, [idToken, userModel]);
};
